<fa-icon class="ps-3 clickable color--white-100-80 color--white-100-hover font-size-12rm"
    [class]="{
        'expanded': isNavBarExpanded()
    }"
    [icon]="['fas', isNavBarExpanded() ? 'arrow-left-from-line' : 'arrow-right-from-line']"
    [tooltip]="isNavBarExpanded() ? 'Collapse' : 'Expand'"
    (click)="toggleNav()"
/>